import styled from 'styled-components';

import { Modal } from 'shared/components/modal/Modals';
import { Button } from 'shared/components/Buttons';
import { TextField } from 'shared/components/form/Inputs';
import { colors, device, fontSizes, fonts } from 'shared/defaultTheme';

export const AttachFormWrapper = styled.div`
  padding-bottom: 1px;
  @media ${device.sm} {
    padding: 0 5px;
    .row {
      display: block;
    }
  }
  @media ${device.md} {
    padding: 0 30px;
    .row {
      display: block;
    }
  }
  @media ${device.lg} {
    padding: 0 30px;
    .row {
      display: flex;
    }
  }
  @media ${device.xl} {
    padding: 0 30px;
    .row {
      display: flex;
    }
  }

  .row-title {
    border-bottom: 1px solid ${colors.spanishGray};
    padding: 0;
    padding-bottom: 17px;
    width: 100%;

    h3 {
      color: ${colors.black};
      font-family: ${fonts.default};
      font-size: ${fontSizes.xlg}px;
      font-weight: bold;
      letter-spacing: 0;
      line-height: 24px;
    }
  }
  .row-content {
    margin-left: 2px;
    padding: 0;
    .col-sm-12 {
      padding: 0;
    }
  }
  .form-field {
    margin-top: 26px;
    .required-mark {
      color: ${colors.error};
    }
    .row {
      padding: 0;
      margin-right: 0;
      margin-left: 0;
    }
  }
  .row-border-bottom {
    border-bottom: 1px solid ${colors.spanishGray};
    padding-bottom: 10px !important;
    margin-bottom: 24px;
  }
  .button-icon {
    background-color: ${colors.transparent};
    color: ${colors.black};
    font-family: ${fonts.default};
    font-size: ${fontSizes.md}px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 19px;
    display: flex;
    flex-direction: row;
    align-items: center;
    width: auto;

    &:active {
      opacity: 0.5;
    }
  }

  @media ${device.sm} {
    .item-tree-folder {
      overflow: auto;
      height: 400px;
      width: 100%;
    }
  }
  @media ${device.md} {
    .item-tree-folder {
      overflow: auto;
      height: 400px;
      width: 100%;
    }
  }
  @media ${device.lg} {
    .item-tree-folder {
      overflow: auto;
      height: 400px;
      width: 100%;
    }
  }
  @media ${device.xl} {
    .item-tree-folder {
      overflow: auto;
      height: 400px;
      width: 100%;
    }
  }
`;

export const Divider = styled.div`
  border-right: 1px solid ${colors.spanishGray};
`;

export const ButtonAction = styled(Button)`
  height: 28px !important;
`;

export const DivFileNameAttachForm = styled.div`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  @media ${device.sm} {
    width: 120px;
    flex: 1 1 auto;
  }
  @media ${device.md} {
    width: 180px;
    flex: 1 1 auto;
  }
  @media ${device.lg} {
    width: 200px;
    flex: 1 1 auto;
  }
  @media ${device.xl} {
    width: 200px;
    flex: 1 1 auto;
  }
`;

export const ActionWraper = styled.div`
  height: 50px;
  display: flex;
`;

export const BoxAttach = styled.div`
  box-sizing: border-box;
  height: auto;
  border: 1px solid ${colors.zambezi};
  border-radius: 2px;
  width: 97%;
  max-height: 191px;
`;

export const TopbarAttach = styled.div`
  background-color: ${colors.zambezi};
  color: ${colors.white};
  height: 31px;
  display: flex;
  align-items: center;
  padding-left: 9px;
`;

export const ScrollAttach = styled.div`
  overflow-y: auto;
  max-height: 148px;
`;

export const TitleClient = styled.span`
  color: ${colors.black};
  font-family: ${fonts.default};
  font-size: 15px;
  font-weight: 500;
`;

export const SerachDocument = styled(TextField)`
  margin-top: 6px !important;
  width: 100% !important;
  height: 38px !important;
  input {
    color: ${colors.gullGrey};
    font-size: ${fontSizes.sm}px;
    letter-spacing: 0;
    line-height: 18px;
  }
`;

export const ItemDataWrapper = styled.div`
  background-color: transparent;
  border: none;
  border-bottom: 1px solid ${colors.lightSilver};
  border-top: 1px solid ${colors.lightSilver};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-top: 10px;
  padding-left: ${({ level }) => 10 * level + 10}px;
  padding-bottom: 5px;
  @media ${device.sm} {
    width: 98%;
  }
  @media ${device.md} {
    width: 98%;
  }
  @media ${device.lg} {
    width: 98%;
  }
  @media ${device.xl} {
    width: 100%;
  }

  .info-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
    width: 70%;
    .folder-icon {
      height: 16px;
      width: 18px;
      fill: ${colors.suvaGrey};
    }
    span {
      color: ${colors.suvaGrey};
      font-family: ${fonts.default};
      font-size: ${fontSizes.sm}px;
      font-weight: 500;
      letter-spacing: 0;
      line-height: 16px;
    }

    .text-file {
      margin-top: -4px;
    }

    .text-folder {
      margin-top: 5px;
      margin-left: 6px;
    }
  }
  .form-check-input {
    position: initial;
    margin-top: 0;
    margin-left: 0;
  }
  input {
    width: 100%;
    padding: 5px 10px;
    font-size: 12px;
    height: 32px;
    transition: border 0.3s;
    background: transparent;
  }
  .caret {
    fill: ${colors.black};
    height: 15px;
    width: 15px;
  }
`;

export const Document = styled.div`
  background-color: transparent;
  border: none;
  border-bottom: 1px solid ${colors.lightSilver};
  border-top: 1px solid ${colors.lightSilver};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: initial;
  padding-top: 10px;
  padding-bottom: 10px;
  width: 100%;
`;

export const FolderListModal = styled(Modal)`
  top: 20%;
  .modal-content {
    border-radius: 4px;
  }
  .modal-header {
    border: 0;
    height: 36px;
    padding-top: 20px;
    padding-bottom: 0;

    svg {
      fill: ${colors.suvaGrey} !important;
      height: 18px !important;
      width: 18px !important;
    }
  }
`;

export const FolderListWrapper = styled.div`
  padding: 0 10px;
  padding-bottom: 1px;
  padding-left: 21px;
  .row-title {
    border-bottom: 1px solid ${colors.spanishGray};
    padding: 0;
    padding-bottom: 17px;
    width: 100%;
    margin-bottom: 21px;

    h3 {
      color: ${colors.black};
      font-family: ${fonts.default};
      font-size: ${fontSizes.xlg}px;
      font-weight: bold;
      letter-spacing: 0;
      line-height: 24px;
    }
  }
  .item-data-container {
    margin-left: -15px;
  }
  .item-tree-container {
    overflow-y: auto;
    height: 400px;
  }
  .action-folder-list {
    display: flex;
    justify-content: end;
    margin-top: 15px;
  }
`;
